export function GraphicalSettingItem({
  title = '',
  link = '',
  icon = 'image-add',
  params = {},
  desc = '',
  templates = [],
}) {
  this.title = title;
  this.link = link;
  this.icon = icon;
  this.params = params;
  this.desc = desc;
  this.templates = templates;
}
